export default "__VITE_PUBLIC_ASSET__be103d92__"